import { Button, ButtonGroup, Card, Flex, Text } from "@mantine/core";
import { useDrawerStore } from "../../../store/dashboard.store";
import { IEvent } from "../../../models/events";
import dayjs from "dayjs";
import { IconEye, IconPencil, IconTrash } from "@tabler/icons-react";
import EditEvent from "./EditEvent";
import ViewEvent from "./ViewEvent";

export default function CardEvent({ event, setDeleteUid }: { event: IEvent, setDeleteUid: (uid: string) => void }) {  
    const addPage = useDrawerStore(state => state.addPage);
    return (
        <>
            <Card  mb="lg">
                <Card.Section p="md">
                    <Flex align="center" justify="space-between">
                        <Text size="sm" fw={500}>{event.type}</Text>
                        <Text size="sm" fw={500}>{dayjs(event.date).format("MMM DD YYYY h:mm A")}</Text>
                    </Flex>
                    <Flex align="center" justify="space-between">
                        <Text size="sm" fw={500}>Registered: {event.patientTotal}</Text>
                        <Text size="sm" fw={500}>Limit: {event.limit}</Text>
                    </Flex>
                    <br/>
                    <Flex direction="column" align="center" content="center" justify="space-between">
                        <ButtonGroup>
                            <Button 
                                leftSection={<IconEye />}
                                size="xs"
                                color="green" onClick={() => {
                                    addPage(<ViewEvent event={event} />, `View Page (Event Id: ${event.uid})`);
                                }}>
                                View
                            </Button>
                            <Button 
                                leftSection={<IconPencil />}
                                size="xs"
                                color="blue" onClick={
                                    () => addPage(<EditEvent event={event} />, `Edit Page (Event Id: ${event.uid})`)
                                }>
                                Edit
                            </Button>
                            {(event.patientTotal ?? 0) == 0 && <Button 
                                leftSection={<IconTrash />}
                                size="xs"
                                color="red" onClick={async () => {
                                    await setDeleteUid(event.uid!);
                                }}>
                                Delete
                            </Button>}
                        </ButtonGroup>
                    </Flex>
                </Card.Section>
            </Card>

        </>
    );
}